import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/register/index', '/user-business-voucher']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  if (to.path.includes('/iframe/go')) {
    store.dispatch('app/full', true);
  } else {
    store.dispatch('app/full', false);
  }
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      next({
        path: '/'
      });
      NProgress.done();
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        next();
      } else {
        try {
          await store.dispatch('user/getInfo');
          await store.dispatch('router/SetAsyncRouter');
          const asyncRouters = store.getters['router/asyncRouters'];
          router.addRoutes(asyncRouters);
          next({
            ...to,
            replace: true
          });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken');
          Message.error(error || 'Has Error');
          next(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/
    if (to.query.token) {
      store.commit('user/SET_TOKEN', {
        token: to.query.token,
        expire: new Date(Number(to.query.expire) + 3600000).toISOString()
      });
      store.commit('user/SET_EXPIRE', Number(to.query.expire) + 3600000);
    }
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
      NProgress.done();
    }
  }
});
router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});